module.exports = __webpack_public_path__ + "static/media/HCMM982.17adfee5.jpg";